import React, { useMemo } from "react";
import "./QuickbarHeading.scss";

const useIcon = icon =>
  useMemo(() => {
    if (icon === undefined) return null;
    const isRenderable = ["string", "number", "boolean"].includes(typeof icon);

    return isRenderable || React.isValidElement(icon)
      ? icon
      : React.createElement(icon);
  }, [icon]);

const QuickbarHeading: React.FC<{
  size: string;
  icon: {
    render: React.ReactNode | React.ComponentType;
  };
  heading: string;
  subHeading?: string;
  className?: string;
}> = props => {
  const size = props.size || "default";

  return (
    <span
      className={`quickbar-heading quickbar-heading--${size} ${props.className}`}
    >
      {props.icon && useIcon(props.icon.render)}
      <span className="quickbar-heading-group">
        {props.heading && (
          <span className="quickbar-heading-label">{props.heading}</span>
        )}
        {props.subHeading && (
          <span className="quickbar-heading-label-sub">{props.subHeading}</span>
        )}
      </span>
    </span>
  );
};

export default QuickbarHeading;
